if (window.innerWidth >= 1024){

        $(document).ready(function() {
            tabClick(1);
        })

        var activeLine =  $(".activeLine");
        function tabClick(index){
            $(".tabDiv").removeClass('activeTab');
            var activeTab = $("#topNavTab-"+index)
            activeTab.addClass('activeTab');

            activeLine.css('width', activeTab.css('width'));
            activeLine.css('left', activeTab.position().left);
            changeTab(index);
        }

        function changeTab(index){
            switch (index){
                case 1:
                    $("#downloadBtnList").css('display','flex');
                    $(".customText").css('display',"none");
                    $(".productDocumentHelpDiv").css('display',"none");
                    break;
                case 2:
                    $("#downloadBtnList").css('display','none');
                    $(".customText").css('display',"flex");
                    $(".productDocumentHelpDiv").css('display',"flex");
                    break;
            }

            activeLine.css('width',$(".activeTab").css('width'));
            activeLine.css('left', $(".activeTab").position().left );
        }

        $(window).resize(function() {
            activeLine.css('width',$(".activeTab").css('width'));
            activeLine.css('left', $(".activeTab").position().left );

        })
    }